import React, { useState, useEffect } from "react";
import { Button, Col, Row, Modal, Input, Select, DatePicker, notification, Upload, Spin} from 'antd'
import { CaretDownOutlined, UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { upload_patient_insurance, upload_patient_insurance_loading, upload_patient_report, upload_patient_report_loading } from "../actions/bookingActions";
import axios from "axios";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import dayjs from 'dayjs';
import { get_v10_url, get_mcm_url } from "../utils/commonUtilities";
import GlobalLoader from "../Components/GlobalLoader";

const { Option } = Select

const documentOptions = [
    {
        label: "Under Writer Evidence",
        value: "UNDER WRITER EVIDENCE"
    },
    {
        label: "Authorization Letter",
        value: "AUTHORIZATION LETTER"
    },
    {
        label: "Pre Authorization Request Form",
        value: "PRE AUTHORIZATION REQUEST FORM",
        disabled: true,
    },
    {
        label: "Final Hospital Bills",
        value: "FINAL HOSPITAL BILLS"
    },
    {
        label: "Investigation Records",
        value: "INVESTIGATION RECORDS"
    },
    {
        label: "Payment Receipts",
        value: "PAYMENT RECEIPTS"
    },
    {
        label: "Pharmacy or Medical Bills",
        value: "PHARMACY OR MEDICAL BILLS"
    },
    {
        label: "Indoor Case Papers",
        value: "INDOOR CASE PAPERS"
    },
    {
        label: "Implants Invoice",
        value: "IMPLANTS INVOICE"
    },
    {
        label: "Implants Label or Sticker",
        value: "IMPLANTS LABEL OR STICKER"
    },
    {
        label: "Prescription Papers",
        value: "PRESCRIPTION PAPERS"
    },
    {
        label: "Consultation Papers",
        value: "CONSULTATION PAPERS"
    },
    {
        label: "Indentity Proof - Aadhar",
        value: "INDENTITY PROOF - AADHAR"
    },
    {
        label: "Others",
        value: "OTHERS"
    },
    {
        label: "Discharge Summary",
        value: "DISCHARGE SUMMARY"
    }
]

const FillPatientDetails = (props) => {

    const dateFormat = 'DD-MMM-YYYY';
    const [openModal, setOpenModal] = useState(false)
    const [insuranceList, setInsuranceList] = useState([])
    const [reportImages, setReportImages] = useState([])
    const [insuranceImages, setInsuranceImages] = useState([])
    const [insurancePdf, setInsurancePdf] = useState("")
    const [reportPdfs, setReportPdfs] = useState([])
    const [loading, setLoading] = useState(false)
    const [message, set_message] = useState(false)
    const [tabIndex, setTabIndex] = useState('1')
    const [userDetails, setUserDetails] = useState({
        mobileNumber: "",
        name: "",
        address: "",
        emailId: "",
        gender: "",
        dob: "",
        age: "",
        hospitalCenter: "",
        treatmentDetails: "",
        treatment: "",
        alternateNumber: "",
        documents: []
    })
    const [newUserDoc, setNewUserDoc] = useState({
        type: null,
        file: '',
        url: ''
    })
    const [userDocs, setUserDocs] = useState([])
    const [uploadedFile, setUploadedFile] = useState(null)
    const [firstUploadFile, setFirstUploadFile] = useState(null)
    const [successModal, setSuccessModal] = useState(false)
    const [firstDoc, setFirstDoc] = useState({
        type: 'PRE AUTHORIZATION REQUEST FORM',
        file: '',
        url: ''
    })

    const [policyDetails, setPolicyDetails] = useState({
        policyNumber: "",
        policyType: "",
        corporatePolicy: "",
        retailPolicy: "",
        insurancePartner: "",
        serviceTPA: "",
        ipNumber: "",
        cardNumber: "",
        doa: "",
        costEstimation: "",
        dod: "",
        roomRent: "",
        iCURent: "",
        nursingCharges: "",
        superSpecialityCharges: "",
        cvc: "",
        soa: "",
        others: "",
        specifiedRoomCategory: "",
        roomCategory: "",
        remarks: "",
        discount: "",
        consultingDoctor: "",
        certificateNumber: "",
        doctorContactNumber: "",
        consultCharges : "",
        treatingSurgeon: "",
        otCharges: "",
        pharmacyCharges: "",
        anestheticFees: "",
        investigation: "",
        others: "",
        totalRoomRent: "",
    })

    const [disableSaveBtn, setDisableSaveBtn] = useState(false)

    const defaultUserData = {
        mobileNumber: "",
        name: "",
        address: "",
        emailId: "",
        gender: "",
        age: "",
        hospitalCenter: "",
        treatmentDetails: "",
        treatment: "",
        alternateNumber: "",
        documents: []
    }

    const defaultPolicyData = {
        policyNumber: "",
        policyType: "",
        corporatePolicy: "",
        insurancePartner: "",
        ipNumber: "",
        cardNumber: "",
        doa: "",
        costEstimation: "",
        dod: "",
        roomRent: "",
        iCURent: "",
        nursingCharges: "",
        superSpecialityCharges: "",
        cvc: "",
        soa: "",
        others: "",
        specifiedRoomCategory: "",
        roomCategory: "",
        remarks: "",
        discount: "",
        consultingDoctor: "",
        certificateNumber: "",
        doctorContactNumber: "",
        consultCharges : "",
        treatingSurgeon: "",
        otCharges: "",
        pharmacyCharges: "",
        anestheticFees: "",
        investigation: "",
        others: "",
        totalRoomRent: "",
    }

    const OpenNotificationWithIcon = (type, heading, message) => {
        notification[type]({
          message: heading,
          description: message,
        });
    };

    useEffect(() => {
        axios.get(`${get_mcm_url()}/insurance`)
        .then(res => {
            const r = res.data
            let arr = [
                {
                    label: 'Cash',
                    value: 'Cash'
                }
            ]
            if(r?.success) {
                r.data.map(item => {
                    arr.push({
                        label: item.insurancePartner,
                        value: item.insurancePartner,
                    })
                })
            }
            setInsuranceList(arr)
        })
        .catch(err => {
            console.error(err)
        })
    }, [])

    useEffect(() => {
        if(userDetails.treatment === "Medical Management") {
            setPolicyDetails({
                ...policyDetails,
                otCharges: '',
                anestheticFees: '',
                soa: '',
            })
        }
    }, [userDetails.treatment])

    useEffect(() => {
        if(policyDetails.policyType === "Retail Policy") {
            setPolicyDetails({
                ...policyDetails,
                corporatePolicy: ""
            })
        }
        if(policyDetails.policyType === "Corporate Policy") {
            setPolicyDetails({
                ...policyDetails,
                retailPolicy: ""
            })
        }
    }, [policyDetails.policyType])

    const getDateString = (date) => {
        let ts = date.split("-")
        ts = ts[0] + "-" + ts[1].charAt(0).toUpperCase() + ts[1].charAt(1).toLowerCase() + ts[1].charAt(2).toLowerCase() + "-" + ts[2]
        return ts
    }

    const handleAddNewDoc = () => {
        if(!newUserDoc.type) {
            OpenNotificationWithIcon('error','Error','Please select a document type for the file to be uploaded')
            return
        }
        if(!newUserDoc.file) {
            OpenNotificationWithIcon('error','Error','Please select a file to be uploaded')
            return
        }
        setUserDocs([
            ...userDocs,
            newUserDoc
        ])
        setUploadedFile(null)
        setNewUserDoc({
            type: null,
            file: '',
            url: ''
        })
    }

    const deleteUserDoc = (index) => {
        // console.warn(index);
        let temp = [...userDocs]
        temp.splice(index,1)
        setUserDocs(temp)
    }

    const docPropsFirst = {
        name: 'file',
        action: `${get_v10_url()}/professional/uploadBookingDoc`,
        accept: "application/pdf",
        headers: {
          authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf'
            const isLess5M = (file.size / 1024 / 1024) < 5
            if (!isPdf) {
                OpenNotificationWithIcon('error','Upload Failed', 'Please upload PDF files only')
            }
            if (!isLess5M) {
                OpenNotificationWithIcon('error','Upload Failed', 'Please upload files with size less than 5 MB')
            }
            return (isPdf && isLess5M) || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if (info.file.status !== 'removed') {
                setFirstUploadFile(info.file)
            }
            if (info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                const resBooking = info.file.response.data
                setFirstDoc({
                    ...firstDoc,
                    url: resBooking.docURL,
                    file: info.file.name
                })
                OpenNotificationWithIcon('success','Upload Succesful', 'Document uploaded successfully')
            } else if (info.file.status === 'error') {
                OpenNotificationWithIcon('error','Upload Failed', "Couldn't upload the document")
            }
        },
        onRemove() {
            setFirstDoc({
                ...firstDoc,
                file: '',
                url: ''
            })
            // console.log(newUserDoc, "WTFF")
            setFirstUploadFile(null)
        }
    }

    const docProps = {
        name: 'file',
        action: `${get_v10_url()}/professional/uploadBookingDoc`,
        accept: "application/pdf",
        headers: {
          authorization: `Bearer ${Cookies.get('token_medical_auth')}`,
        },
        beforeUpload: (file) => {
            const isPdf = file.type === 'application/pdf'
            const isLess5M = (file.size / 1024 / 1024) < 5
            if (!isPdf) {
                OpenNotificationWithIcon('error','Upload Failed', 'Please upload PDF files only')
            }
            if (!isLess5M) {
                OpenNotificationWithIcon('error','Upload Failed', 'Please upload files with size less than 5 MB')
            }
            return (isPdf && isLess5M) || Upload.LIST_IGNORE;
        },
        onChange(info) {
            if (info.file.status !== 'removed') {
                setUploadedFile(info.file)
            }
            if (info.file.status !== 'uploading') {
                // console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                const resBooking = info.file.response.data
                setNewUserDoc({
                    ...newUserDoc,
                    url: resBooking.docURL,
                    file: info.file.name
                })
                OpenNotificationWithIcon('success','Upload Succesful', 'Document uploaded successfully')
            } else if (info.file.status === 'error') {
                OpenNotificationWithIcon('error','Upload Failed', "Couldn't upload the document")
            }
        },
        onRemove() {
            setNewUserDoc({
                type: null,
                file: '',
                url: ''
            })
            // console.log(newUserDoc, "WTFF")
            setUploadedFile(null)
        }
    }

    const handleBack = () => {
        if (tabIndex > '1') {
            setTabIndex((prevIndex) => String(parseInt(prevIndex) - 1));
        }
    }

    const checkEmptyUser = () => {
        let flag = true
        if(userDetails.mobileNumber === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Mobile number cannot be empty')
            return
        } if (userDetails.mobileNumber.length !== 10) {
            flag = false
            OpenNotificationWithIcon('error','Error','Please enter 10 digits mobile number')
            return
        } if(userDetails.alternateNumber!=="" && userDetails.alternateNumber.length !== 10) {
            flag = false
            OpenNotificationWithIcon('error','Error','Please enter 10-digits alternate mobile number')
            return
        } if (userDetails.name === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Name cannot be empty')
            return
        } if (userDetails.address === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Address cannot be empty')
            return
        } if (userDetails.emailId === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Email cannot be empty')
            return
        } 
        if (userDetails.gender === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Gender cannot be empty')
            return
        } 
        if (userDetails.treatment === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Treatment cannot be empty')
            return
        } 
        if (userDetails.age === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Age cannot be empty')
            return
        } if (userDetails.emailId !== '') {
            const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(!emailRegex.test(userDetails.emailId)) {
                flag = false
                OpenNotificationWithIcon('error', 'Error', 'Please enter a valid email address')
                return
            }
        } if (userDetails.age < 0) {
            flag = false
            OpenNotificationWithIcon('error', 'Error', 'Age cannot be negative')
            return
        } if (userDetails.treatmentDetails === "") {
            flag = false
            OpenNotificationWithIcon('error', 'Error', 'Procedure details cannot be empty')
            return
        }

        return flag
    }

    const checkEmptyPolicy = () => {
        let flag = true
        if (policyDetails.policyNumber === '' && policyDetails.insurancePartner!=="Cash") {
            flag = false
            OpenNotificationWithIcon('error','Error','Policy number cannot be empty')
            return
        } 
        // if (policyDetails.ipNumber === '') {
        //     flag = false
        //     OpenNotificationWithIcon('error','Error','IPD number cannot be empty')
        // } 
        if (policyDetails.insurancePartner === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Please Select Insurance')
            return
        } if (policyDetails.serviceTPA === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Please Select Insurance Company Name')
            return
        } if (policyDetails.doa === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Date of admission cannot be empty')
            return
        } if (policyDetails.dod === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Date of discharge cannot be empty')
            return
        } if (policyDetails.costEstimation === '' || policyDetails.costEstimation == 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Cost estimation cannot be empty or 0')
            return
        } if (policyDetails.costEstimation < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Cost estimation cannot be negative')
            return
        } 
        // if (policyDetails.discount === '') {
        //     flag = false
        //     OpenNotificationWithIcon('error','Error','Discount cannot be empty')
        // } 
        if (policyDetails.discount!=="" && policyDetails.discount < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Discount cannot be negative')
            return
        } if (policyDetails.investigation < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Investigation cannot be negative')
            return
        } if (policyDetails.others < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Others cannot be negative')
            return
        } if (dayjs(policyDetails.dod).isBefore(dayjs(policyDetails.doa))) {
            flag = false
            OpenNotificationWithIcon('error','Error','Date of admission cannot be after date of discharge')
            return
        } if (policyDetails.roomRent < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Room rent/day cannot be negative')
            return
        } if (policyDetails.nursingCharges < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Nursing charge cannot be negative')
            return
        } if (userDetails.treatment === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Treatment cannot be empty')
            return
        } 
        if(policyDetails.totalRoomRent === "" || policyDetails.totalRoomRent < 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Total Room Rent cannot be empty or negative",
            });
            return
        }
        if(policyDetails.cardNumber === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "UHID/Member ID cannot be empty",
            });
            return
        }
        
        if(policyDetails.roomCategory === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Room Category cannot be empty",
            });
            return
        }

        if(policyDetails.roomCategory === "OTHERS") {
            if(policyDetails.specifiedRoomCategory === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Please specify the room category",
                });
                return
            }
        }

        if(userDetails.treatment == 'Medical Management'){
            if(policyDetails.consultingDoctor === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Consulting Doctor Name cannot be empty",
                });
                return
            }
        }
        if(userDetails.treatment == 'Surgical Management'){
            if(policyDetails.treatingSurgeon === "") {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Treating Surgeon's Name cannot be empty",
                });
                return
            }
            if(policyDetails.otCharges === "" || policyDetails.otCharges == 0 || policyDetails.otCharges < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "OT Charges cannot be empty, 0 or negative",
                });
                return
            }
            if(policyDetails.anestheticFees === "" || policyDetails.anestheticFees == 0 || policyDetails.anestheticFees < 0) {
                flag = false
                notification["error"]({
                    message: "Error",
                    description: "Anaesthetist Fees cannot be empty, 0 or negative",
                });
                return
            }
            if (policyDetails.soa === '' || policyDetails.soa == 0 || policyDetails.soa < 0) {
                flag = false
                OpenNotificationWithIcon('error','Error','Surgeon fee cannot be empty, 0 or negative')
                return
            }
        }
        
        if(policyDetails.certificateNumber === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Medical Certificate Number cannot be empty",
            });
            return
        }

        if(policyDetails.doctorContactNumber === "") {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Doctor Contact Number cannot be empty",
            });
            return
        }
        if(policyDetails.doctorContactNumber !== "" && policyDetails.doctorContactNumber.length !== 10) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Doctor Contact Number cannot be less/more than 10 digits",
            });
            return
        }
        if(policyDetails.cvc === "" || policyDetails.cvc == 0 || policyDetails.cvc < 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Doctor Consultation/Visit Charges cannot be empty, 0 or negative",
            });
            return
        }
        if(policyDetails.pharmacyCharges === "" || policyDetails.pharmacyCharges == 0 || policyDetails.pharmacyCharges < 0) {
            flag = false
            notification["error"]({
                message: "Error",
                description: "Pharmacy Charges/Consumables cannot be empty, 0 or negative",
            });
            return
        }
        if (policyDetails.policyType==="" && policyDetails.insurancePartner!=="Cash" ) {
            flag = false
            OpenNotificationWithIcon('error','Error','Policy type cannot be empty')
            return
        }
        if (policyDetails.policyType==="Corporate Policy" && (policyDetails.corporatePolicy===undefined || policyDetails.corporatePolicy==="")  && policyDetails.insurancePartner!=="Cash" ) {
            flag = false
            OpenNotificationWithIcon('error','Error','Corporate policy name cannot be empty if policy type is corporate')
            return
        }
        if (policyDetails.policyType==="Retail Policy" && (policyDetails.retailPolicy===undefined || policyDetails.retailPolicy==="")  && policyDetails.insurancePartner!=="Cash" ) {
            flag = false
            OpenNotificationWithIcon('error','Error','Retail policy name cannot be empty if policy type is retail')
            return
        }

        return flag
    }

    const handleSetPage2 = () => {
        if(checkEmptyUser()) {
            setTabIndex('2')
        }
    }

    const handleSetPage3 = () => {
        if(checkEmptyUser()) {
            if(checkEmptyPolicy()) {
                setTabIndex('3')
            }
        }
    }

    const handleNext = () => {
        if (tabIndex==='1' && tabIndex < '3') {
            if (checkEmptyUser()) {
                // console.warn(tabIndex);
                setTabIndex((prevIndex) => String(parseInt(prevIndex) + 1));
            }
        }

        if (tabIndex==='2' && tabIndex < '3') {
            if (checkEmptyUser() && checkEmptyPolicy()) {
                // console.warn(tabIndex);
                setTabIndex((prevIndex) => String(parseInt(prevIndex) + 1));
            }
        }
    }

    const handleSubmit = async () => {
        let flag = true
        if(userDetails.mobileNumber === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Mobile number cannot be empty')
            return
        } else if (userDetails.name === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Name cannot be empty')
            return
        } else if (userDetails.address === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Address cannot be empty')
            return
        } else if (userDetails.emailId === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Email cannot be empty')
            return
        } else if (userDetails.gender === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Gender cannot be empty')
            return
        } else if (userDetails.age === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Age cannot be empty')
            return
        } else if (policyDetails.policyNumber === '' && policyDetails.insurancePartner!=="Cash") {
            flag = false
            OpenNotificationWithIcon('error','Error','Policy number cannot be empty')
            return
        } else if (policyDetails.insurancePartner === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Please Select Insurance')
            return
        } else if (policyDetails.serviceTPA === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Please Select Insurance Company Name')
            return
        } else if (policyDetails.doa === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Date of admission cannot be empty')
            return
        } else if (policyDetails.dod === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Date of discharge cannot be empty')
            return
        } else if (policyDetails.costEstimation === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Cost estimation cannot be empty')
            return
        } else if (policyDetails.costEstimation < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Cost estimation cannot be negative')
            return
        } else if (dayjs(policyDetails.dod).isBefore(dayjs(policyDetails.doa))) {
            flag = false
            OpenNotificationWithIcon('error','Error','Date of admission cannot be after date of discharge')
            return
        } else if (policyDetails.roomRent < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Room rent/day cannot be negative')
            return
        } else if (policyDetails.nursingCharges < 0) {
            flag = false
            OpenNotificationWithIcon('error','Error','Nursing charge cannot be negative')
            return
        } else if (userDetails.treatment === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Treatment cannot be empty')
            return
        } else if (firstDoc.url === '') {
            flag = false
            OpenNotificationWithIcon('error','Error','Please upload pre authorization request form')
            return
        }
        else if(policyDetails.totalRoomRent === "") {
            flag = false
            OpenNotificationWithIcon('error','Error','Total Room Rent Cannot be Empty')
            return
        }

        if(flag) {
            setLoading(true)
            // await uploadDocs()
            setDisableSaveBtn(true)
            let finalFiles = []
            for (let i=0; i<userDocs.length; i++) {
                finalFiles.push({
                    docType: userDocs[i].type,
                    docURL: userDocs[i].url
                })
            }
            finalFiles.push({
                docType: firstDoc.type,
                docURL: firstDoc.url
            })
            setUserDetails({
                ...userDetails,
                documents: finalFiles
            })
            let verifiedUser = await getUserDetails()
            CreateBooking(verifiedUser._id, finalFiles)
        }
    }

    const getUserDetails = async () => {
        const headers = {
            Authorization: `Bearer ${Cookies.get('token_medical_auth') }`
        }
        let obj = {
            name: userDetails.name,
            mobileNumber: userDetails.mobileNumber,
            userType: 'User',
            email: userDetails.emailId,
            fromPanel: true,
            gender: userDetails.gender,
            address: userDetails.address,
            age: userDetails.age
        }
        try {
            const userData = await axios.post(`${get_v10_url()}/professional/validateUser`, obj, {headers})
            return userData.data.data
        } catch (error) {
            OpenNotificationWithIcon('error',"Error",'An Error Occured!! Please try again later.')
            setDisableSaveBtn(false)
        }
    }

    const CreateBooking = async (userId, files) => {
        const headers = {
            Authorization: `Bearer ${Cookies.get('token_medical_auth') }`
        }
        const booking = {
            date: policyDetails.doa,
            timeSlot: '9:00 AM',
            bookingStatus: 'Requested',
            creditsUsed: false,
            doctorId: null,
            paymentPercent: 100,
            price: policyDetails.costEstimation,
            userId: userId,
            ipNumber: policyDetails.ipNumber,
            cardNumber: policyDetails.cardNumber,
            doa: policyDetails.doa,
            treatmentDetails: userDetails.treatmentDetails,
            treatment: userDetails.treatment,
            patientSex: userDetails.gender,
            patientAge: userDetails.age,
            patientDob: userDetails.dob,
            userAlternateNumber: userDetails.alternateNumber,
            patientAlternateNumber: userDetails.alternateNumber,
            hospitalCenter: userDetails.hospitalCenter,
            remarks: policyDetails.remarks,
            dod: policyDetails.dod,
            documents: files,
            doctorName: policyDetails.consultingDoctor,
            medicalCertificateNumber: policyDetails.certificateNumber,
            doctorContactNumber: policyDetails.doctorContactNumber,
            treatingSurgeon: policyDetails.treatingSurgeon,
            bookingFrom: "HOSPITAL",
            paymentDetails: {
                roomRent: policyDetails.roomRent,
                roomCategory: policyDetails.roomCategory!=='' ? policyDetails.roomCategory : 'OTHERS',
                specifiedRoomCategory: policyDetails.specifiedRoomCategory,
                iCURent: policyDetails.iCURent,
                nursingCharges: policyDetails.nursingCharges,
                superSpecialityCharges: policyDetails.superSpecialityCharges,
                soa: policyDetails.soa,
                others: policyDetails.others,
                discount: policyDetails.discount,
                medicineConsumables: policyDetails.pharmacyCharges,
                investigation: policyDetails.investigation,
                otCharges: policyDetails.otCharges,
                anesthetist: policyDetails.anestheticFees,
                cvc: policyDetails.cvc,
                totalRoomRent: policyDetails.totalRoomRent,
            },
        }
        if (policyDetails.insurancePartner !== 'Cash') {
            booking.haveInsurance = true
            booking.insuranceDetails = {
                policyNumber: policyDetails.policyNumber,
                policyType: policyDetails.policyType,
                insuranceCard: insuranceImages,
                insurancePolicy: insurancePdf,
                insurancePartner: policyDetails.insurancePartner,
                corporatePolicy: policyDetails.corporatePolicy,
                retailPolicy: policyDetails.retailPolicy,
                serviceTPA: policyDetails.serviceTPA,
            }
        }
        try {
            let bookingResult = await axios.post(`${get_v10_url()}/professional/createManualBooking`, booking, {headers})
            if(bookingResult.data.success) {
                setUserDetails(defaultUserData)
                setPolicyDetails(defaultPolicyData)
                setFirstDoc({
                    type: 'PRE AUTHORIZATION REQUEST FORM',
                    file: '',
                    url: ''
                })
                setUserDocs([])
                setFirstUploadFile(null)
                setUploadedFile(null)
                setTabIndex('1')
                setDisableSaveBtn(false)
                setOpenModal(false)
                setSuccessModal(true)
            }
        } catch (error) {
            OpenNotificationWithIcon('error',"Error","An Error Occured!! Please try again later")
            setDisableSaveBtn(false)
        }

        setLoading(false)
    }
    useEffect(()=>{
        if(policyDetails.doa && policyDetails.dod && policyDetails.roomRent){
            let totalRent = (dayjs(policyDetails.dod, dateFormat).diff(dayjs(policyDetails.doa, dateFormat), 'day')) * (policyDetails.roomRent)
            setPolicyDetails({...policyDetails, totalRoomRent:totalRent});
        }
        else{
            setPolicyDetails({...policyDetails, totalRoomRent:''});
        }

    },[policyDetails.doa, policyDetails.dod, policyDetails.roomRent])

    useEffect(()=>{
        if(userDetails.treatment === "Medical Management"){
            const total = (Number(policyDetails.totalRoomRent) || 0) + (Number(policyDetails.cvc) || 0) + (Number(policyDetails.pharmacyCharges) || 0) + (Number(policyDetails.others) || 0) + (Number(policyDetails.investigation) || 0) - (Number(policyDetails.discount) || 0);
            setPolicyDetails({...policyDetails, costEstimation: total });
        }
        else if(userDetails.treatment === "Surgical Management"){
            const total = (Number(policyDetails.totalRoomRent) || 0) + (Number(policyDetails.cvc) || 0) +(Number(policyDetails.soa) || 0) +(Number(policyDetails.otCharges) || 0) + (Number(policyDetails.anestheticFees) || 0)  + (Number(policyDetails.pharmacyCharges) || 0) + (Number(policyDetails.others) || 0) + (Number(policyDetails.investigation) || 0) - (Number(policyDetails.discount) || 0);
            setPolicyDetails({...policyDetails, costEstimation: total});
        }

    },[policyDetails.totalRoomRent, policyDetails.cvc, policyDetails.pharmacyCharges, policyDetails.soa, policyDetails.otCharges, policyDetails.anestheticFees, policyDetails.others, policyDetails.investigation, policyDetails.discount]);

    return (
        <>
        {disableSaveBtn && <GlobalLoader/>}
        <div className="fill-details-container">
            <h3>Fill Patient Details</h3>
            <Row gutter={24} style={{marginBottom:'1rem'}}>
                <Col span={8}>
                    <label>Patient Name*</label>
                    <Input type="text" className="details-input" placeholder="Patient Name" value={userDetails.name} onChange={(e)=> setUserDetails({...userDetails, name:e.target.value})}/>
                </Col>
                <Col span={4}>
                    <label>DOB</label>
                    <DatePicker
                    className="details-input"
                    value={userDetails.dob ? dayjs(userDetails.dob, dateFormat) : null}
                    format={dateFormat}
                    onChange={(date, dateString) => {
                            if(date === null) {
                                setUserDetails({
                                    ...userDetails,
                                    dob: null
                                })
                            }
                            else if (dateString) {
                                const age = dayjs().diff(dayjs(dateString), 'year');
                                setUserDetails({
                                    ...userDetails,
                                    dob: dateString,
                                    age: age
                            })
                        }
                    }}
                    placeholder='DOB'
                    name='dob'
                    getPopupContainer={trigger => trigger.parentElement}
                    />
                </Col>
                <Col span={4}>
                    <label>Age*</label>
                    <Input type="number" className="details-input" placeholder="00 yrs" value={userDetails.age} onChange={(e)=> setUserDetails({...userDetails, age:e.target.value})}/>
                </Col>
                <Col span={8}>
                    <label>Gender*</label>
                    <Select className="details-input selection-input" 
                        suffixIcon={<CaretDownOutlined style={{color:'#04D0D9'}}/>} placeholder="Select Gender-"
                        type='select'
                        options={[
                            {
                                label: 'Male',
                                value: 'M'
                            },
                            {
                                label: 'Female',
                                value: 'F'
                            },
                            {
                                label: 'Other',
                                value: 'O'
                            },
                        ]}
                        onChange={e => setUserDetails({...userDetails, gender: e})}
                        isMulti={false}
                        blurInputOnSelect={true}
                        closeMenuOnSelect={true}
                        value={userDetails.gender || undefined}
                        label = "Gender"
                        getPopupContainer={trigger => trigger.parentElement}
                    />
                </Col>
            </Row>
            <Row gutter={24}>
                <Col span={8}>
                    <label>Mobile No.*</label>
                    <Input className="details-input" placeholder="+91 0000000000" value={userDetails.mobileNumber} onChange={(e)=> setUserDetails({...userDetails, mobileNumber:e.target.value})}/>
                </Col>
                <Col span={8}>
                    <label>Patient Email*</label>
                    <Input className="details-input" placeholder="example@gmail.com" value={userDetails.emailId} onChange={(e)=> setUserDetails({...userDetails, emailId:e.target.value})}/>
                </Col>
                <Col span={8}>
                    <label>Insurance Partner/Cash*</label>
                    {insuranceList && <Select
                        type='select'
                        options={insuranceList}
                        name="insurance"
                        value={policyDetails.insurancePartner || undefined}
                        placeholder='Choose Insurance'
                        className="details-input selection-input"
                        isMulti={true}
                        blurInputOnSelect={true}
                        closeMenuOnSelect={true}
                        onChange={(e)=> {
                            setPolicyDetails((prev)=>({
                                ...prev, insurancePartner: e,
                                ...(e==="Cash" ? {policyType:"", policyNumber:"", corporatePolicy:""} : {})
                            }))
                        }}
                        suffixIcon={<CaretDownOutlined style={{color:'#04D0D9'}}/>}
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input,option)=>{
                            return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                        }}
                        filterSort={(opA,opB) => {
                            return (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                        }}
                        getPopupContainer={trigger => trigger.parentElement}
                        listHeight={4*32}
                    />}
                </Col>
            </Row>
            <h2 onClick={()=>setOpenModal(true)}>Submit Patient Details</h2>
        </div>
        <Modal
            width='70%'
            visible={openModal}
            className='create-manual-booking-modal'
            title={`Create New Booking ${tabIndex}/3`}
            onCancel={() => setOpenModal(false)}
            onOk={() => setOpenModal(false)}
        >
            <div className="modal-body-heading">
                <h2 className={`${tabIndex==='1' ? 'active' : ''}`} onClick={()=>setTabIndex('1')}>Patient Details</h2>
                <h2 className={`${tabIndex==='2' ? 'active' : ''}`} onClick={handleSetPage2}>Policy Details</h2>
                <h2 className={`${tabIndex==='3' ? 'active' : ''}`} onClick={handleSetPage3}>Documents</h2>
            </div>
            {tabIndex==='1' && (
                <>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Patient Name*</label>
                        <Input type="text" className="details-input" placeholder="Patient Name" value={userDetails.name} onChange={(e)=> setUserDetails({...userDetails, name:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>DOB</label>
                        <DatePicker
                        className="details-input"
                        value={userDetails.dob ? dayjs(userDetails.dob, dateFormat) : null}
                        format={dateFormat}
                        onChange={(date, dateString) => {
                            if(date === null) {
                                setUserDetails({
                                    ...userDetails,
                                    dob: null
                                })
                            }
                            else if (dateString) {
                                const age = dayjs().diff(dayjs(dateString), 'year');
                                setUserDetails({
                                    ...userDetails,
                                    dob: dateString,
                                    age: age
                                })
                            }
                        }}
                        placeholder='DOB'
                        name='dob'
                        getPopupContainer={trigger => trigger.parentElement}
                        />
                    </Col>
                    <Col span={8}>
                        <label>Age*</label>
                        <Input type="number" className="details-input" placeholder="00 yrs" value={userDetails.age} onChange={(e)=> setUserDetails({...userDetails, age:e.target.value})}/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Gender*</label>
                        <Select className="details-input selection-input"
                            suffixIcon={<CaretDownOutlined style={{color:'#04D0D9'}}/>} placeholder="Select Gender-"
                            type='select'
                            options={[
                                {
                                    label: 'Male',
                                    value: 'M'
                                },
                                {
                                    label: 'Female',
                                    value: 'F'
                                },
                                {
                                    label: 'Other',
                                    value: 'O'
                                },
                            ]}
                            onChange={e => setUserDetails({...userDetails, gender: e})}
                            isMulti={false}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            value={userDetails.gender || undefined}
                            label = "Gender"
                            getPopupContainer={trigger => trigger.parentElement}
                        />
                    </Col>
                    <Col span={8}>
                        <label>Mobile No.*</label>
                        <Input type="number" className="details-input" placeholder="+91 0000000000" value={userDetails.mobileNumber} onChange={(e)=> setUserDetails({...userDetails, mobileNumber:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>Alternate No.</label>
                        <Input type="number" className="details-input" placeholder="+91 0000000000" value={userDetails.alternateNumber} onChange={(e)=> setUserDetails({...userDetails, alternateNumber:e.target.value})}/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Patient Email*</label>
                        <Input className="details-input" placeholder="example@gmail.com" value={userDetails.emailId} onChange={(e)=> setUserDetails({...userDetails, emailId:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>Treatment Type*</label>
                        <Select
                            type="select"
                            options = {[
                                {
                                    label:'Medical Management',
                                    value:'Medical Management'
                                },
                                {
                                    label:'Surgical Management',
                                    value:'Surgical Management'
                                },
                            ]}
                            onChange={(e)=> setUserDetails({...userDetails, treatment:e})}
                            isMulti ={false}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            className="details-input selection-input"
                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                            value = {userDetails.treatment || undefined}
                            placeholder='Select Treatment Type'
                            label = "Treatment-Type" 
                        />
                    </Col>
                    {/* <Col span={8}>
                        <label>Center Name</label>
                        <Input className="details-input" placeholder="Center Name" value={userDetails.hospitalCenter} onChange={(e)=> setUserDetails({...userDetails, hospitalCenter:e.target.value})}/>
                    </Col> */}
                    <Col span={8}>
                        <label>Patient Address*</label>
                        <textarea rows={1} className="details-input" value={userDetails.address} onChange={(e)=> setUserDetails({...userDetails, address:e.target.value})} placeholder="Enter address"/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <label>Procedure Details*</label>
                        <textarea rows={4} className="details-input" value={userDetails.treatmentDetails} onChange={(e)=> setUserDetails({...userDetails, treatmentDetails:e.target.value})} placeholder="Enter patient details"/>
                    </Col>
                </Row>
                <div className="booking-modal-btn-container">
                    <Button onClick={(e)=>{setOpenModal(false)}} className="back-btn">Cancel</Button>
                    <Button onClick={handleSetPage2} className="submit-next-btn">Next</Button>
                </div>
                </>
            )}

            {tabIndex==='2' && (
                <>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Insurance Partner/Cash*</label>
                        {insuranceList && <Select
                            type='select'
                            options={insuranceList}
                            name="insurance"
                            value={policyDetails.insurancePartner || undefined}
                            placeholder='Choose Insurance'
                            className="details-input selection-input"
                            isMulti={true}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            onChange={(e)=> {
                                setPolicyDetails((prev)=>({...prev, insurancePartner:e,
                                    ...(e==="Cash" ? {policyType:"", policyNumber:"", corporatePolicy:""} : {})
                                }))
                            }}
                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input,option)=>{
                                return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }}
                            filterSort={(opA,opB) => {
                                return (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                            }}
                            getPopupContainer={trigger => trigger.parentElement}
                            listHeight={4*32}
                        />}
                    </Col>
                    <Col span={8}>
                        <label>Insurance Company Name*</label>
                        <Select
                            type='select'
                            options={[
                                {label: "N/A", value: "NA"},
                                {label: "Bajaj Allianz General Insurance Co. Ltd", value: "Bajaj Allianz General Insurance Co. Ltd"},
                                {label: "Cholamandalam MS General Insurance Co. Ltd", value: "Cholamandalam MS General Insurance Co. Ltd"},
                                {label: "Navi General Insurance Ltd.", value: "Navi General Insurance Ltd."},
                                {label: "Future Generali India Insurance Co. Ltd.", value: "Future Generali India Insurance Co. Ltd."},
                                {label: "HDFC ERGO General Insurance Co. Ltd", value: "HDFC ERGO General Insurance Co. Ltd"},
                                {label: "IFFCO-TOKIO General Insurance Co. Ltd.", value: "IFFCO-TOKIO General Insurance Co. Ltd."},
                                {label: "ICICI Lombard General Insurance Co. Ltd.", value: "ICICI Lombard General Insurance Co. Ltd."},
                                {label: "Kotak Mahindra General insurance co. Ltd.", value: "Kotak Mahindra General insurance co. Ltd."},
                                {label: "Liberty  General Insurance Co. Ltd.", value: "Liberty  General Insurance Co. Ltd."},
                                {label: "Magma HDI General Insurance Co. Ltd.", value: "Magma HDI General Insurance Co. Ltd."},
                                {label: "National Insurance Co. Ltd.", value: "National Insurance Co. Ltd."},
                                {label: "Raheja QBE General Insurance Co. Ltd.", value: "Raheja QBE General Insurance Co. Ltd."},
                                {label: "Reliance General Insurance Co. Ltd.", value: "Reliance General Insurance Co. Ltd."},
                                {label: "Royal Sundaram General Insurance Co. Ltd", value: "Royal Sundaram General Insurance Co. Ltd"},
                                {label: "SBI General Insurance Co. Ltd.", value: "SBI General Insurance Co. Ltd."},
                                {label: "Shriram General Insurance Co. Ltd.", value: "Shriram General Insurance Co. Ltd."},
                                {label: "Tata-AIG General Insurance Co. Ltd.", value: "Tata-AIG General Insurance Co. Ltd."},
                                {label: "The New India Assurance Co. Ltd.", value: "The New India Assurance Co. Ltd."},
                                {label: "The Oriental Insurance Co. Ltd.", value: "The Oriental Insurance Co. Ltd."},
                                {label: "Universal Sompo General Insurance Co. Ltd.", value: "Universal Sompo General Insurance Co. Ltd."},
                                {label: "United India Insurance Co. Ltd.", value: "United India Insurance Co. Ltd."},
                                {label: "Acko General Insurance Ltd.", value: "Acko General Insurance Ltd."},
                                {label: "Edelweiss General Insurance Company Limited ", value: "Edelweiss General Insurance Company Limited "},
                                {label: "Go Digit General Insurance Limited", value: "Go Digit General Insurance Limited"},
                                {label: "Aditya Birla Health insurance Co Ltd.", value: "Aditya Birla Health insurance Co Ltd."},
                                {label: "Manipal Cigna Health Insurance Company Limited", value: "Manipal Cigna Health Insurance Company Limited"},
                                {label: "Niva bupa health insurance company limited", value: "Niva bupa health insurance company limited"},
                                {label: "Care Health Insurance Ltd", value: "Care Health Insurance Ltd"},
                                {label: "Star Health & Allied Insurance Co. Ltd", value: "Star Health & Allied Insurance Co. Ltd"},
                            ]}
                            name="insurance"
                            value={policyDetails.serviceTPA || undefined}
                            placeholder='Choose Insurance Company'
                            className="details-input selection-input"
                            isMulti={true}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            onChange={(e)=> {
                                setPolicyDetails((prev)=>({...prev, serviceTPA:e,}))
                            }}
                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input,option)=>{
                                return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                            }}
                            filterSort={(opA,opB) => {
                                return (opA?.label ?? '').toLowerCase().localeCompare((opB?.label ?? '').toLowerCase())
                            }}
                            getPopupContainer={trigger => trigger.parentElement}
                            listHeight={4*32}
                        />
                    </Col>
                    <Col span={8}>
                        <label>Policy Type{policyDetails.insurancePartner !== "Cash" && '*'}</label>
                        <Select
                            type='select'
                            options = {[
                                {
                                    label: "Retail Policy",
                                    value: "Retail Policy",
                                },
                                {
                                    label: "Corporate Policy",
                                    value: "Corporate Policy",
                                },
                            ]}
                            name="policytype"
                            value={policyDetails.policyType || undefined}
                            placeholder='Choose Policy Type'
                            className="details-input selection-input"
                            isMulti={true}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            onChange={(e)=> setPolicyDetails({...policyDetails, policyType:e})}
                            disabled={policyDetails.insurancePartner === "Cash"}
                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    {policyDetails.policyType!=="Corporate Policy" && <Col span={8}>
                        <label>Retail Name{policyDetails.policyType==="Retail Policy" && policyDetails.insurancePartner !== "Cash" && "*"}</label>
                        <Input disabled={policyDetails.policyType==="Corporate Policy" || policyDetails.insurancePartner === "Cash"} className="details-input" placeholder='Enter Retail Name' value={policyDetails.retailPolicy} onChange={(e)=> setPolicyDetails({...policyDetails, retailPolicy:e.target.value})}/>
                    </Col>}
                    {policyDetails.policyType==="Corporate Policy" && <Col span={8}>
                        <label>Name of Corporate{policyDetails.policyType==="Corporate Policy" && policyDetails.insurancePartner !== "Cash" && "*"}</label>
                        <Input disabled={policyDetails.policyType==="Retail Policy" || policyDetails.insurancePartner === "Cash"} className="details-input" placeholder='Enter Name of Corporate' value={policyDetails.corporatePolicy} onChange={(e)=> setPolicyDetails({...policyDetails, corporatePolicy:e.target.value})}/>
                    </Col>}
                    <Col span={8}>
                        <label>Policy No.{policyDetails.insurancePartner !== "Cash" && '*'}</label>
                        <Input className="details-input" placeholder="Policy Number" value={policyDetails.policyNumber} disabled={policyDetails.insurancePartner === "Cash"} onChange={(e)=> setPolicyDetails({...policyDetails, policyNumber:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>UHID/Member ID*</label>
                        <Input className="details-input" placeholder="XXXX XXXX XXXX XXXX" value={policyDetails.cardNumber} onChange={(e)=> setPolicyDetails({...policyDetails, cardNumber:e.target.value})}/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Treatment Type</label>
                        <Input disabled={true} value = {userDetails.treatment} className="details-input" placeholder={`${userDetails.treatment}`} />
                    </Col>
                    <Col span={8}>
                        <label>Expected DOA (Date Of Admission)*</label>
                        <DatePicker
                            className="details-input date-pick-input"
                            placeholder="Select Date-"
                            onChange={(date, dateString) => setPolicyDetails({...policyDetails, doa: date ? date.format(dateFormat) : null})}
                            format={dateFormat}
                            value = {policyDetails.doa ? dayjs(policyDetails.doa, dateFormat) : null}
                            getPopupContainer={trigger => trigger.parentElement}
                        />
                    </Col>
                    <Col span={8}>
                        <label>Date of Discharged*</label>
                        <DatePicker
                            className="details-input date-pick-input"
                            placeholder="Select Date-"
                            onChange={(date, dateString) => setPolicyDetails({...policyDetails, dod: date ? date.format(dateFormat) : null})}
                            format={dateFormat}
                            value = {policyDetails.dod ? dayjs(policyDetails.dod, dateFormat) : null}
                            getPopupContainer={trigger => trigger.parentElement}
                        />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Discount</label>
                        <Input type="number" className="details-input" placeholder="₹ 00.00" value={policyDetails.discount} onChange={(e)=> setPolicyDetails({...policyDetails, discount:e.target.value})}/>
                    </Col>
                    <Col span={policyDetails.roomCategory=="OTHERS" ? 4 : 8}>
                        <label>Room Category*</label>
                        <Select
                            type="select"
                            options = {[
                                {
                                    label:'General',
                                    value:'GENERAL'
                                },
                                {
                                    label:'Private',
                                    value:'PRIVATE'
                                },
                                {
                                    label:'Private AC',
                                    value:'PRIVATE AC'
                                },
                                {
                                    label:'Twin Categoy',
                                    value:'TWIN CATEGORY'
                                },
                                {
                                    label:'Deluxe',
                                    value:'DELUXE'
                                },
                                {
                                    label:'Super Deluxe',
                                    value:'SUPER DELUXE'
                                },
                                {
                                    label:'NICU',
                                    value:'NICU'
                                },
                                {
                                    label:'ICU',
                                    value:'ICU'
                                },
                                {
                                    label:'Others',
                                    value:'OTHERS'
                                },
                            ]}
                            value={policyDetails.roomCategory || undefined}
                            onChange={(e) => setPolicyDetails({...policyDetails, roomCategory:e})}
                            isMulti ={false}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            className="details-input selection-input"
                            placeholder='Select Room Category'
                            label = "Room Categoy"
                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                            getPopupContainer={trigger => trigger.parentElement}
                        />
                    </Col>
                    {policyDetails.roomCategory=="OTHERS" && 
                        <Col span={4}>
                            <label>Please Specify*</label>
                            <Input
                                className="details-input"
                                type='text'
                                value={policyDetails.specifiedRoomCategory}
                                onChange={(e)=> setPolicyDetails({...policyDetails, specifiedRoomCategory:e.target.value})}
                                placeholder="Please Specify"
                                required={policyDetails.roomCategory=="OTHERS"}
                                name='specifiedRoomCategory'
                            />
                        </Col>}
                    <Col span={8}>
                        <label>Room Rent/Day*</label>
                        <Input type="number" className="details-input" placeholder="₹ 00.00" value={policyDetails.roomRent} onChange={(e)=> setPolicyDetails({...policyDetails, roomRent:e.target.value})}/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Total Room Rent*</label>
                        <Input disabled={true} type="number"  value = {policyDetails.totalRoomRent} className="details-input"  placeholder={"Enter DOA, DOD and Room Rent/Day first"}/>
                    </Col>
                    { userDetails.treatment =="Medical Management" ? (
                        <Col span={8}>
                            <label>Consulting Doctor Name*</label>
                            <Input disabled={loading} value = {policyDetails.consultingDoctor} onChange={(e)=> setPolicyDetails({...policyDetails, consultingDoctor:e.target.value})} className="details-input" placeholder='Enter Consulting Doctor Name' />
                        </Col>
                    ) : userDetails.treatment == 'Surgical Management' ? (
                        <Col span={8}>
                            <label>Treating Surgeon's Name*</label>
                            <Input disabled={loading} value = {policyDetails.treatingSurgeon} onChange={(e)=> setPolicyDetails({...policyDetails, treatingSurgeon:e.target.value})} className="details-input" placeholder="Enter Treating Surgeon's Name" />
                        </Col> 
                    ) : (<></>)}
                    <Col span={8}>
                        <label>Medical Certificate Number*</label>
                        <Input disabled={loading} value = {policyDetails.certificateNumber} onChange={(e)=> setPolicyDetails({...policyDetails, certificateNumber:e.target.value})} className="details-input" placeholder='Enter Medical Certificate Number' />
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Doctor Contact Number*</label>
                        <Input type="number" disabled={loading} value = {policyDetails.doctorContactNumber} onChange={(e)=> setPolicyDetails({...policyDetails, doctorContactNumber:e.target.value})} className="details-input" placeholder='Enter Doctor Contact Number' />
                    </Col>
                    { userDetails.treatment =="Medical Management" ? (
                        <>
                            <Col span={8}>
                                <label>Pharmacy Charges/ Consumables*</label>
                                <Input disabled={loading} value = {policyDetails.pharmacyCharges} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, pharmacyCharges:e.target.value})} className="details-input"placeholder='₹ 00.00' />
                            </Col>
                            <Col span={8}>
                                <label>Investigation Charges (If Any)</label>
                                <Input type="number" disabled={loading} value = {policyDetails.investigation} onChange={(e)=> setPolicyDetails({...policyDetails, investigation:e.target.value})} className="details-input" placeholder='Enter Ivestigation (If any)' />
                            </Col>
                        </>
                        
                    ) : userDetails.treatment == 'Surgical Management' ? (
                        <>
                        <Col span={8}>
                            <label>Surgeon Fee*</label>
                            <Input disabled={loading} value = {policyDetails.soa} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, soa:e.target.value})} className="details-input" placeholder='₹ 00.00' />
                        </Col>
                        <Col span={8}>
                            <label>OT Charges*</label>
                            <Input disabled={loading} value = {policyDetails.otCharges} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, otCharges:e.target.value})} className="details-input" placeholder='₹ 00.00' />
                        </Col>
                        </>
                    ) : (<></>)}
                </Row>
                {userDetails.treatment == 'Surgical Management' && (
                    <Row gutter={24}>
                        <Col span={8}>
                        <label>Anaesthetist Fees*</label>
                        <Input disabled={loading} value = {policyDetails.anestheticFees} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, anestheticFees:e.target.value})} className="details-input" placeholder='₹ 00.00' />

                        </Col>
                        <Col span={8}>
                            <label>Pharmacy Charges/ Consumables*</label>
                            <Input disabled={loading} value = {policyDetails.pharmacyCharges} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, pharmacyCharges:e.target.value})} className="details-input" placeholder='₹ 00.00' />
                        </Col>
                        <Col span={8}>
                            <label>Investigation (If Any)</label>
                            <Input disabled={loading} value = {policyDetails.investigation} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, investigation:e.target.value})} className="details-input" placeholder='₹ 00.00' />
                        </Col>
                    </Row>
                )}
                <Row gutter={24}>
                    <Col span={8}>
                        <label>Doctor Consultation/Visit Charges*</label>
                        <Input disabled={loading} value = {policyDetails.cvc} type="number" onChange={(e)=> setPolicyDetails({...policyDetails, cvc:e.target.value})} className="details-input" placeholder='₹ 00.00' />
                    </Col>
                    <Col span={8}>
                        <label>Others</label>
                        <Input disabled={loading} value = {policyDetails.others} onChange={(e)=> setPolicyDetails({...policyDetails, others:e.target.value})} className="details-input" placeholder='Others' />
                    </Col>
                    <Col span={8}>
                        <label>Total Cost Estimation (₹)*</label>
                        <Input disabled={true} type='number' value = {policyDetails.costEstimation} className="details-input" placeholder= {"Enter all costs first"}/>

                    </Col>
                </Row>
                {/* <Row gutter={24}>
                    <Col span={8}>
                        <label>Surgeon Fee</label>
                        <Input type="number" className="details-input" placeholder="₹ 00.00" value={policyDetails.soa} onChange={(e)=> setPolicyDetails({...policyDetails, soa:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>Cost Estimationt (₹)*</label>
                        <Input type="number" className="details-input" placeholder="₹ 00.00" value={policyDetails.costEstimation} onChange={(e)=> setPolicyDetails({...policyDetails, costEstimation:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>Discount</label>
                        <Input type="number" className="details-input" placeholder="₹ 00.00" value={policyDetails.discount} onChange={(e)=> setPolicyDetails({...policyDetails, discount:e.target.value})}/>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={8}>
                        <label>IPD Number*</label>
                        <Input className="details-input" placeholder="IPD Number" value={policyDetails.ipNumber} onChange={(e)=> setPolicyDetails({...policyDetails, ipNumber:e.target.value})}/>
                    </Col>
                    <Col span={8}>
                        <label>Room Category</label>
                        <Select
                            type="select"
                            options = {[
                                {
                                    label:'General',
                                    value:'GENERAL'
                                },
                                {
                                    label:'Private',
                                    value:'PRIVATE'
                                },
                                {
                                    label:'Twin Categoy',
                                    value:'TWIN CATEGORY'
                                },
                                {
                                    label:'Deluxe',
                                    value:'DELUXE'
                                },
                                {
                                    label:'Super Deluxe',
                                    value:'SUPER DELUXE'
                                },
                                {
                                    label:'NICU',
                                    value:'NICU'
                                },
                                {
                                    label:'ICU',
                                    value:'ICU'
                                }
                            ]}
                            value={policyDetails.roomCategory || undefined}
                            onChange={(e) => setPolicyDetails({...policyDetails, roomCategory:e})}
                            isMulti ={false}
                            blurInputOnSelect={true}
                            closeMenuOnSelect={true}
                            className="details-input selection-input"
                            placeholder='Select Room Category'
                            label = "Room Categoy"
                            suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                            getPopupContainer={trigger => trigger.parentElement}
                        />
                    </Col>
                    <Col span={8}>
                        <label>Room Rent/Day</label>
                        <Input type="number" className="details-input" placeholder="₹ 00.00" value={policyDetails.roomRent} onChange={(e)=> setPolicyDetails({...policyDetails, roomRent:e.target.value})}/>
                    </Col>
                </Row> */}
                {/* <Row gutter={24}>
                    <Col span={8}>
                        <label>Card Number</label>
                        <Input className="details-input" placeholder="XXXX XXXX XXXX XXXX" value={policyDetails.cardNumber} onChange={(e)=> setPolicyDetails({...policyDetails, cardNumber:e.target.value})}/>
                    </Col>
                </Row> */}
                <div className="booking-modal-btn-container">
                    <Button onClick={()=>setTabIndex('1')} className="back-btn">Back</Button>
                    <Button onClick={handleSetPage3} className="submit-next-btn">Next</Button>
                </div>
                </>
            )}

            {tabIndex==='3' && (
                <>
                <Row gutter={24}>
                    <Col span={24}>
                        <label>Attach Pre Authorization Request Form*</label>
                        <Row gutter={24}>
                            <Col span={12}>
                                <Select
                                    type='select'
                                    disabled={true}
                                    options={documentOptions}
                                    isMulti={false}
                                    blurInputOnSelect={true}
                                    closeMenuOnSelect={true}
                                    placeholder='Select Document Type'
                                    className="details-input selection-input"
                                    label="Document Type"
                                    value={firstDoc.type || undefined}
                                    suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                    onChange={(e) => setNewUserDoc({ ...newUserDoc, type: e })}
                                    getPopupContainer={trigger => trigger.parentElement}
                                />
                                </Col>
                            <Col span={6}>
                                <Upload className="modal-upload-container" {...docPropsFirst} id="userDocUploadDash_id" fileList={firstUploadFile ? [firstUploadFile] : []}>
                                    <Button icon={<UploadOutlined/>} className="modal-upload-btn">Upload Doc</Button>
                                </Upload>
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row gutter={24}>
                    <Col span={24}>
                        <label>Attach Reports and Prescription</label>
                        <Row gutter={24} style={{ marginTop: '10px' }}>
                            {
                                userDocs.map((doc,index) => (
                                    <div className="uploaded-shown-docs">
                                        <Row key={index}>
                                            <Col span={12} style={{ paddingRight: '20px' }}>
                                                <Select
                                                    disabled={true}
                                                    type="select"
                                                    value={doc.type}
                                                    style={{ width: '100%' }}
                                                    className="details-input selection-input"
                                                />
                                            </Col>
                                            <Col span={6}>
                                                <Input
                                                    disabled={true}
                                                    type="text"
                                                    value={doc.file}
                                                    className="details-input"
                                                />
                                            </Col>
                                            <Col span={6}>
                                                <Button type='link' className="remove-link" onClick={()=>deleteUserDoc(index)}>Remove</Button>
                                            </Col>
                                        </Row>
                                    </div>
                                ))
                            }
                                <Col span={12}>
                                    <Select
                                        type='select'
                                        options={documentOptions}
                                        isMulti={false}
                                        blurInputOnSelect={true}
                                        closeMenuOnSelect={true}
                                        placeholder='Select Document Type'
                                        className="details-input selection-input"
                                        label="Document Type"
                                        value={newUserDoc.type || undefined}
                                        suffixIcon={<CaretDownOutlined style={{color:'#30C118'}}/>}
                                        onChange={(e) => setNewUserDoc({ ...newUserDoc, type: e })}
                                        getPopupContainer={trigger => trigger.parentElement}
                                    />
                                </Col>
                                <Col span={6}>
                                    <Upload className="modal-upload-container" {...docProps} id="userDocUploadDash_id" fileList={uploadedFile ? [uploadedFile] : []}>
                                        <Button icon={<UploadOutlined/>} className="modal-upload-btn">Upload Doc</Button>
                                    </Upload>
                                </Col>
                                <Col span={6}>
                                    <Button className="add-new-doc-btn" onClick={handleAddNewDoc}>Add</Button>
                                </Col>
                        </Row>
                    </Col>
                </Row>
                <div className="booking-modal-btn-container">
                    <Button onClick={()=>setTabIndex('2')} className="back-btn">Back</Button>
                    <Button onClick={(e) => {e.preventDefault(); handleSubmit();}} className="submit-next-btn" disabled={disableSaveBtn}>Submit</Button>
                </div>
                </>
            )}

        </Modal>
        <Modal
            width={600}
            visible={successModal}
            className='success-modal'
            onCancel={() => setSuccessModal(false)}
            onOk={() => setSuccessModal(false)}
        >
            <div>
                <h4>Successfully Filled The Details</h4>
                <p>You will received the status within 2 hrs.</p>
                <div className="success-img">
                    <img src={require('../Assets/images/success-animation.gif')} alt="Success GIF" />
                </div>
            </div>
        </Modal>
        </>
    )
}

export default FillPatientDetails